import React, { useCallback } from 'react';
import { useMasterNoteItem, useMasterNoteSection, useUpdateEntity } from 'hooks/store.hooks';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import BaseAction from './BaseAction';
import { ENTITY_MASTER_NOTE_SECTION } from 'constants/schemas';
import PropTypes from 'prop-types';

function MasterNoteItemActionMoveDown(props) {
  const { id, ...restProps } = props;
  const update = useUpdateEntity();
  const section = useMasterNoteItem(id, 'master_note_section');
  const sectionItems = useMasterNoteSection(section, 'items');
  const sequence = sectionItems.indexOf(id);

  const onAction = useCallback(() => {
    const newSectionItems = [...sectionItems];
    const newSequence = sequence + 1;
    newSectionItems.splice(sequence, 1);
    newSectionItems.splice(newSequence, 0, id);
    update({ type: ENTITY_MASTER_NOTE_SECTION, id: section, key: 'items', value: newSectionItems });
  }, [id, section, sectionItems, sequence, update]);

  return (
    <BaseAction
      icon={<ArrowDownwardIcon />}
      label='Move Down'
      onAction={onAction}
      disabled={sequence < 0 || sequence + 1 === sectionItems.length}
      {...restProps}
    />
  );
}

MasterNoteItemActionMoveDown.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default MasterNoteItemActionMoveDown;
